/**
 * Content policy option ids i.e. the user subcription id
 * provided by user entitlment
 * @module services/content-policy/option-ids
 */

/**
 * Content policy for origial basic subscription
 * @deprecated This will remain for backwards compatibiliy
 * with Sony PS3, but most likely you want CONTENT_POLICY_OPTION_SUB_MONTHLY
 */
export const CONTENT_POLICY_OPTION_SUB_BASIC = 252

/**
 * Content policy basic subscription
 */
export const CONTENT_POLICY_OPTION_SUB_MONTHLY = 253

/**
 * Content policy annual subscription
 */
export const CONTENT_POLICY_OPTION_SUB_ANNUAL = 280

/**
 * Content policy premium subscription
 */
export const CONTENT_POLICY_OPTION_SUB_LIVE_ACCESS = 290

/**
 * Content policy available to any subscription
 */
export const CONTENT_POLICY_OPTION_FREE = 255

/**
 * Content policy alacarte
 */
export const CONTENT_POLICY_OPTION_ALACARTE = 222

/**
 * Content policy AI subscription
 */
export const CONTENT_POLICY_OPTION_SUB_AI_ONLY = 200

export function getOptionIdsOptions () {
  return [
    { label: 'Sub Basic', value: CONTENT_POLICY_OPTION_SUB_BASIC },
    { label: 'AI Only', value: CONTENT_POLICY_OPTION_SUB_AI_ONLY },
    { label: 'Sub Monthly', value: CONTENT_POLICY_OPTION_SUB_MONTHLY },
    { label: 'Sub Annual', value: CONTENT_POLICY_OPTION_SUB_ANNUAL },
    { label: 'Live Access', value: CONTENT_POLICY_OPTION_SUB_LIVE_ACCESS },
    { label: 'Free', value: CONTENT_POLICY_OPTION_FREE },
    { label: 'Alacarte', value: CONTENT_POLICY_OPTION_ALACARTE },
  ]
}
